import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { TEAM, memberPath } from '../data/team';
import Reveal from './Reveal';
import './TeamGrid.css';

function TeamGrid() {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <section className="team-section">
      <div className="container">
        <div className="team-list">
          {TEAM.map((member) => {
            const bio = isEn ? member.bioEn : member.bio;
            const href = memberPath(member.slug);

            return (
              <Reveal key={member.slug}>
                <article className="team-member">
                  <Link to={href} className="team-member-photo" aria-label={member.name}>
                    <img
                      src={`${process.env.PUBLIC_URL}/${member.image}`}
                      alt={member.name}
                      loading="lazy"
                    />
                  </Link>
                  <div className="team-member-info">
                    <h2 className="team-member-name">
                      <Link to={href}>{member.name}</Link>
                    </h2>
                    <p className="team-member-title">{isEn ? member.titleEn : member.title}</p>
                    {bio && <p className="team-member-bio">{bio}</p>}
                    <Link to={href} className="team-member-link">
                      {isEn ? 'View profile' : 'Ver perfil'}
                    </Link>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default TeamGrid;
